/* eslint-disable eqeqeq */
/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * ButtonPad.web.js - Numpad view for the subitise screens.
 */

import React from 'react';
import './ButtonPad.web.css';
import PropTypes from 'prop-types';
import { SubitisingCategoryName } from '../../categories';

const numbers0To5 = ['0', '1', '2', '3', '4', '5'];
const numbers1To5 = ['1', '2', '3', '4', '5'];
const numbers5To9 = ['5', '6', '7', '8', '9'];
const numbers1To9 = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const numbers0To10 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export default class ButtonPad extends React.Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

  _handleKeyboardDown(event) {

    if (event.code == 'Tab') {
      event.stopPropagation();
      event.preventDefault();

    } else {
      let value;
      switch (event.code) {
        case 'Digit1':
        case 'Numpad1':
        {
          value = '1';
          break;
        }
        case 'Digit2':
        case 'Numpad2':
        {
          value = '2';
          break;
        }
        case 'Digit3':
        case 'Numpad3':
        {
          value = '3';
          break;
        }
        case 'Digit4':
        case 'Numpad4':
        {
          value = '4';
          break;
        }
        case 'Digit5':
        case 'Numpad5':
        {
          value = '5';
          break;
        }
        case 'Digit6':
        case 'Numpad6':
        {
          value = '6';
          break;
        }
        case 'Digit7':
        case 'Numpad7':
        {
          value = '7';
          break;
        }
        case 'Digit8':
        case 'Numpad8':
        {
          value = '8';
          break;
        }
        case 'Digit9':
        case 'Numpad9':
        {
          value = '9';
          break;
        }
        case 'Digit0':
        case 'Numpad0':
        {
          value = '0';
          break;
        }
        default: {
          return;
        }
      }

      this.props.handleInputEvent(value);

    }
  }

  _handleOnButtonFocus() {
    const element = document.getElementById('questions_content');
    if (element) {
      element.focus();
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this._handleKeyboardDown.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener('keyDown', this._handleKeyboardDown.bind(this));
  }

  render() {

    let numbers = numbers1To5;

    if (this.props.category == SubitisingCategoryName.FIVE_FRAME_1
      || this.props.category == SubitisingCategoryName.MAGIC_MIX_SUBITISING_1
    ) {
      numbers = numbers0To5;
    } else if (this.props.category == SubitisingCategoryName.TEN_FRAME_1) {
      numbers = numbers0To10;
    } else if (this.props.category == SubitisingCategoryName.FIVE_TO_NINE_1) {
      numbers = numbers5To9;
    } else if (this.props.category == SubitisingCategoryName.ONE_TO_NINE_1) {
      numbers = numbers1To9;
    }

    return (
      <div className="subitise_pad">
        {numbers.map((value, index) => {
          if (this.props.category == SubitisingCategoryName.ONE_TO_NINE_1) {
            return (
              <button
                key={index}
                className="subitise_numpad_wider_button"
                onClick={() => this.props.handleInputEvent(value)}
                disabled={this.props.disabled}
              >
                <p className="subitise_numpad_button_text_1_9">{value}</p>
              </button>
            );
          }
          if (this.props.category == SubitisingCategoryName.TEN_FRAME_1) {
            return (
              <button
                key={index}
                className="subitise_numpad_button"
                onClick={() => this.props.handleInputEvent(value)}
                disabled={this.props.disabled}
              >
                <p className="subitise_numpad_button_text_1_9">{value}</p>
              </button>
            );
          }

          return (
            <button
              key={index}
              className="subitise_numpad_button"
              onClick={() => this.props.handleInputEvent(value)}
              disabled={this.props.disabled}
            >
              <p className="subitise_numpad_button_text_1_5">{value}</p>
            </button>
          );

        })}
      </div>
    );
  }
}

ButtonPad.propTypes = {
  props: PropTypes.object,
  handleInputEvent: PropTypes.func,
  category: PropTypes.string,
  disabled: PropTypes.bool
};
